module.exports = __webpack_public_path__ + "static/media/cover-ka.713e098b.png";